import { Observable } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { inject } from '@angular/core'
import { Store } from '@ngrx/store'

import { AppState } from '../core.state'

import { persistentUserRoleSelectors } from 'src/app/features/role/user-role/persistent-user-role/persistent-user-role.selector'

export function UserRoleHttpHeaderInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const store = inject(Store<AppState>)

  return store.select(persistentUserRoleSelectors.selectSelectedUserRole).pipe(
    take(1),
    switchMap((userRole) => {
      if (
        userRole &&
        typeof userRole?.id == 'number' &&
        req.url.includes(environment.backendApiUrl)
      ) {
        const clonedReq = req.clone({
          setHeaders: {
            'x-user-role-id': userRole.id + ''
          }
        })

        return next(clonedReq)
      }

      return next(req)
    })
  )
}
